module.exports = __webpack_public_path__ + "static/cloudmb-0b7a165f7b2a11b0cc4b148ce0449b8a.png";